import { action, computed, observable } from "mobx";
import { ModelBase } from "Core/Models/ModelBase";

import { IsPhoneNumber, Length, IsEmail, IsNotEmpty } from "class-validator";

export interface EmailModelDTO {
    email: string;
    projectName: string;
}

export class EmailModel extends ModelBase<EmailModel, EmailModelDTO> {
    @observable
    @IsNotEmpty({ message: "Email is required" })
    @IsEmail({}, { message: "Email address format is not correct" })
    @Length(1, 256, { message: "Email address length is not correct" })
    public email: string = "";

    @observable
    @IsNotEmpty({ message: "Project name is required" })
    @Length(1, 256, { message: "Project name length is not correct" })
    public projectName: string = "";

    fromDto(model: EmailModelDTO): void {
        throw new Error("Method not implemented.");
    }

    toDto(model: EmailModel): EmailModelDTO {
        const retVal: EmailModelDTO = {
            email: this.email,
            projectName: this.projectName,
        };
        return retVal;
    }
}
